import { render, staticRenderFns } from "./agreementDetail.vue?vue&type=template&id=9bb3ae60&scoped=true"
import script from "./agreementDetail.vue?vue&type=script&lang=js"
export * from "./agreementDetail.vue?vue&type=script&lang=js"
import style0 from "./agreementDetail.vue?vue&type=style&index=0&id=9bb3ae60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb3ae60",
  null
  
)

export default component.exports